import PresupuestoService from '@/services/PresupuestoService';
import { Notify } from 'quasar';
import { defineStore } from 'pinia';
import { useStorage } from '@vueuse/core';
import { router } from "@inertiajs/vue3"

export const useCartStore = defineStore('cart', {
    state: () => ({
        items: useStorage('items', []),
        presupuesto: useStorage('presupuesto', {}),
        open: false,
        obra: useStorage('obra', {}),
        mode: useStorage('mode', 'add'),
        itemToEdit: useStorage('itemToEdit', {}),
        loadingStatus: false,
    }),

    getters: {
        getMode: (state) => state.mode,
        itemTotal: (state) => state.items.length,
        isOpened: (state) => state.open,
        getObra: (state) => state.obra,
        getLoadingStatus: (state) => state.loadingStatus,
        getPresupuesto: (state) => state.presupuesto,
        getItemsToDB: (state) => {
            return state.items.map(({ form, producto }) => {
                delete form.producto;
                return {
                    ...form,
                    panel: form?.panel?.value,
                    lista_precio_id: producto.listaPrecioID,
                    lista_precio_valor: producto.precio,
                    local_id: '',
                    producto_id: producto.productoID,
                    plazo: parseInt(producto.plazo),
                    total: form.total,
                    webGroupID: producto.webGroupID.trim(),
                };
            });
        },
        getItemToEdit: (state) => state.itemToEdit,
    },

    actions: {
        clear() {
            this.items = [];
            this.presupuesto = {};
            this.obra = {};
            this.open = false;
        },
        setItemsFromDB(data) {
            this.presupuesto = {
                presupuesto_id: data.id,
                fecha_necesidad: data.fecha_necesidad,
                vendedor_id: data.vendedor_id,
                condicion_pago: {
                    value: data.condicion_pago.E4_CODIGO,
                    label: data.condicion_pago.E4_DESCRI,
                },
            };
            this.obra = {
                id: data.obra.id,
                referencia: data.obra.referencia,
                cliente_id: data.obra.cliente_id,
            };
            this.items = data.items.map((item) => {
                const productoDesc = item.producto_id.trim() === 'WCAMNOST' ? 'CAMARA NO ESTANDAR' : item.producto?.B1_DESC;
                const webGroupID = item.producto_id.trim() === 'WCAMNOST' ? 'WCAM' : item.producto?.B1_WGRUP;
                return {
                    form: { ...item },
                    producto: {
                        productoID: item.producto_id,
                        productoDesc,
                        label: item.producto_id,
                        precio: item.lista_precio_valor,
                        listaPrecioID: item.lista_precio_id,
                        webGroupID,
                    },
                };
            });
        },
        setPresupuesto(data) {
            this.presupuesto = data;
        },
        setObra(obra) {
            this.obra = obra;
        },
        mapItemToDB({form, producto}) {
            return {
                ...form,
                panel: form?.panel?.value,
                lista_precio_id: producto.listaPrecioID,
                lista_precio_valor: producto.precio,
                local_id: '',
                producto_id: producto.productoID,
                plazo: parseInt(producto.plazo),
                total: form.total,
                webGroupID: producto.webGroupID.trim(),
            };
        },
        async itemAdd(item, isSavedPresup = false, presupuestoId = null) {
            this.setLoadingStatus(true);
            try {
                if (isSavedPresup) {
                    await PresupuestoService.itemAdd(presupuestoId, this.mapItemToDB(item))
                    router.visit(`/presupuestos/${presupuestoId}`, {
                        preserveState: true
                    })
                    return;
                } else {
                    item.form.id = crypto.randomUUID();
                    item.form.status = 'temporal'
                    this.items.push(item);
                    Notify.create({
                        message: 'Item agregado al carrito',
                        color: 'green',
                        position: 'bottom',
                        icon: 'shopping_cart',
                    });
                }

            } catch (error) {
                console.error('Error adding item:', error);
            } finally {
                this.setLoadingStatus(false);

            }
        },
        async itemUpdate(item, isSavedPresup = false, presupuestoId = null) {
            this.setLoadingStatus(true);
            try {
                if (isSavedPresup) {
                    await PresupuestoService.itemUpdate(presupuestoId, this.mapItemToDB(item))
                    router.visit(`/presupuestos/${presupuestoId}`, {
                        preserveState: true
                    })
                    return;
                } else {
                    const index = this.items.findIndex((i) => i.form.id === item.form.id);
                    this.items.splice(index, 1, item);
                }

            } catch (error) {
                console.error('Error adding item:', error);
            } finally {
                this.setLoadingStatus(false);

            }
        },
        toggle() {
            this.open = !this.open;
        },
        async itemDelete(itemId, isSavedPresup = false, presupuestoId = null) {
            try {
                if (isSavedPresup) {
                    await PresupuestoService.itemDelete(presupuestoId, itemId)
                    router.visit(`/presupuestos/${presupuestoId}`, {
                        only: ['presup', 'total', 'totalEmp']
                    })
                    return;
                } else {
                    const index = this.items.findIndex((i) => i.form.id === itemId);
                    this.items.splice(index, 1);
                }

            } catch (error) {
                console.error('Error adding item:', error);
            } finally {
                this.setLoadingStatus(false);

            }

        },
        itemEdit(item) {
            this.itemToEdit = item;
        },
        setMode(mode) {
            if (mode === 'add') this.clear();
            this.mode = mode;
        },
        setLoadingStatus(status) {
            this.loadingStatus = status;
        }
    },
});
